module.exports = __webpack_public_path__ + "static/media/food_trucks.56263680.mp4";